export default {"src":"/_next/static/media/oneturfLogo.6535cb9d.svg","height":33,"width":33};